import type { ReactNode } from 'react';
import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { QuestionnairePreviewScreen } from './pages/QuestionnairePreviewScreen';
import { QuestionnairesBuilderScreen } from './pages/QuestionnairesBuilderScreen';
import { QuestionnairesListScreen } from './pages/QuestionnairesListScreen';

const guarded = (element: ReactNode) => (
  <ProtectedRoute>
    <OnboardingCompletionGuard>{element}</OnboardingCompletionGuard>
  </ProtectedRoute>
);

export const questionnairesRoutes = (
  <>
    <Route path="/questionnaires" element={guarded(<QuestionnairesListScreen />)} />
    <Route
      path="/questionnaires/:questionnaireId/builder"
      element={guarded(<QuestionnairesBuilderScreen />)}
    />
    {/* Full-size walkthrough of the real form. Admin-only and stores nothing — see the screen. */}
    <Route
      path="/questionnaires/:questionnaireId/preview"
      element={guarded(<QuestionnairePreviewScreen />)}
    />
  </>
);
